import { render, staticRenderFns } from "./up_scan.vue?vue&type=template&id=2ddb65f4&scoped=true&"
import script from "./up_scan.vue?vue&type=script&lang=js&"
export * from "./up_scan.vue?vue&type=script&lang=js&"
import style0 from "./up_scan.vue?vue&type=style&index=0&id=2ddb65f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb65f4",
  null
  
)

export default component.exports